import { render, staticRenderFns } from "./ChoiceGoods.vue?vue&type=template&id=701bd733&scoped=true&"
import script from "./ChoiceGoods.vue?vue&type=script&lang=ts&"
export * from "./ChoiceGoods.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceGoods.vue?vue&type=style&index=0&id=701bd733&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bd733",
  null
  
)

export default component.exports